export const STATUSES = {
    confirmed: {
        label: 'Подтверждён',
        value: 'confirmed'
    },
    unconfirmed: {
        label: 'Не подтверждён',
        value: 'unconfirmed'
    }
};
